import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Paper, TableContainer } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { StudentRow } from "./studentBranchLinkApi";

interface Props {
  rows: StudentRow[];
  onLink: (row: StudentRow) => void;
  onEdit: (row: StudentRow) => void;
  onRemove: (row: StudentRow) => void;
}

const StudentBranchLinkTable: React.FC<Props> = ({ rows, onLink, onEdit, onRemove }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Admission No</TableCell>
            <TableCell>Scholar No</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Section</TableCell>
            <TableCell>Linked Branch</TableCell>
            <TableCell>Primary Branch</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.studentId}>
              <TableCell>{r.admissionNumber}</TableCell>
              <TableCell>{r.scholarNumber || "-"}</TableCell>
              <TableCell>{r.studentName}</TableCell>
              <TableCell>{r.class}</TableCell>
              <TableCell>{r.section}</TableCell>
              <TableCell>{r.linkedBranch || "-"}</TableCell>
              <TableCell>{r.isPrimaryBranch ? "Yes" : "No"}</TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => onLink(r)} title="Link Branch">
                  <LinkIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onEdit(r)} title="Edit Link">
                  <EditIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onRemove(r)} title="Remove Link">
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={8} align="center">
                No students found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentBranchLinkTable;
